import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import {
  StyledProductsSourceControllerProps,
  StyledProductsSourceControllerStyleProps,
} from './ProductsSourceController.interface';

export const StyledProductsSourceControllerBox = styled(Box, {
  shouldForwardProp: (prop: PropertyKey): boolean => prop !== 'disabled',
})<StyledProductsSourceControllerProps>(
  ({ disabled }: StyledProductsSourceControllerStyleProps) => ({
    padding: '26px 26px 0',
    width: '100%',
    pointerEvents: disabled ? 'none' : 'auto',
  }),
);
